import React, { useState } from "react";
import weblogo from "assets/img/logo.png";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "components/header/header.css";

export default function Header() {
  const [expanded, setExpanded] = useState(false);
  const closeNavbar = () => setExpanded(false);

  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/", { state: "Pricing" });
  };

  return (
    <div className="container d-flex justify-content-between align-items-center">
      <Navbar
        expand="lg"
        expanded={expanded}
        className="w-100 d-flex justify-content-between me-0 me-lg-5"

      >
        <Navbar.Brand>
          <div className="logo">
            <Link to="/">
              <img className="img-fluid" src={weblogo} alt="logo" />
            </Link>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(!expanded)}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav onClick={closeNavbar}>
            <NavLink className="nav-link" to="/">
              Home
            </NavLink>
            <NavLink className="nav-link pointer" to={"/pricing-plan"}>
              Pricing
            </NavLink>
            <Link
              className="nav-link"
              to="/order-a-device/"
            >
              Order a Device
            </Link>
            <Link
              className="nav-link"
              to="/book-a-demo/"
            >
              Book a Demo
            </Link>
            {/* <Link
              className="nav-link"
              to="/get-a-free-quote/"
            >
              Get a Free Quote
            </Link> */}
            <NavLink className="nav-link" to="/blog">
              Blog
            </NavLink>

            {/* Show Community link inside navbar only on mobile */}
            <NavLink
              className="nav-link d-lg-none"
              to="https://social.techgv.co.uk/sign-in"
              target="_blank"
              rel="noopener noreferrer"
            >
              Community
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {/* Show Community button only on desktop */}
      <p className="fade-right d-none d-lg-block" style={{ textAlign: "center" }}>
        <Link
          to="https://social.techgv.co.uk/sign-in"
          className="btn btn-outline-white btn-No-Login"
          target="_blank"
          rel="noopener noreferrer"
        >
          Community
        </Link>
      </p>
    </div>
  );
}
